var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapsSquareButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0857 9.16453C9.9733 9.2728 9.82303 9.33333 9.66663 9.33333C9.51023 9.33333 9.35996 9.2728 9.24756 9.16453C8.21803 8.16693 6.8383 7.05253 7.51116 5.43458C7.87496 4.55977 8.74823 4 9.66663 4C10.585 4 11.4583 4.55977 11.8221 5.43458C12.4941 7.05047 11.1178 8.17033 10.0857 9.16453Z",
    stroke: "#0020F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66675 6.33337H9.67275",
    stroke: "#0020F5",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 7.99996C1.66675 5.0144 1.66675 3.52162 2.59424 2.59412C3.52174 1.66663 5.01452 1.66663 8.00008 1.66663C10.9856 1.66663 12.4784 1.66663 13.4059 2.59412C14.3334 3.52162 14.3334 5.0144 14.3334 7.99996C14.3334 10.9855 14.3334 12.4783 13.4059 13.4058C12.4784 14.3333 10.9856 14.3333 8.00008 14.3333C5.01452 14.3333 3.52174 14.3333 2.59424 13.4058C1.66675 12.4783 1.66675 10.9855 1.66675 7.99996Z",
    stroke: "#0020F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 14L2 4.66663",
    stroke: "#0020F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 9.33337L2.66675 13.3334",
    stroke: "#0020F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapsSquareButton);
export default __webpack_public_path__ + "static/media/maps-square-button.ce6db963d51f53c0c8841aff47a43600.svg";
export { ForwardRef as ReactComponent };